import Vue from 'vue'
import CartService from "@/services/Cart.js"
import {axios} from "@/utils"

const state = {
    cart: null,
    cartExists: false,
    shippingAddressExists: false,
    shippingAddressChanged: false,
    voucherCheckinId: null,
    campaign: localStorage.getItem('campaign') || '',
}


const getters = {
    cartExists: state => state.cartExists,
    containsDigitalItems: state => state.cart && state.cart.digital_items && state.cart.digital_items.length > 0,

    getDigitalItems: state => state.cart ? state.cart.digital_items : [],
    getDigitalItemById: state => id => state.cart.digital_items.find(item => item.id === id),
    getDigitalItemByPicacode: state => picacode => state.cart ? state.cart.digital_items.find(item => item.checkin.picacode === picacode) : {},

    isDigitalPhotoInCart: (state, getters) => (picacode, photoId) => {
        const digitalItem = getters.getDigitalItemByPicacode(picacode)
        if (digitalItem)
            return (digitalItem.photos || []).find(photo => photo.id === photoId)
    },

    isDigitalPhotoInCartById: (state) => (photoId) => {
        let found = false
        state.cart.digital_items.forEach((item) => {
            let photo = item.photos.find(photo => photo.id === photoId)
            console.log('photo found?', photo)
        })
        return found
    },

    containsPrintItems: state => state.cart && state.cart.print_items.length > 0,

    getPrintItems: state => state.cart ? state.cart.print_items : [],

    // il controllo non è forte (===) perchè dall'address bar del browser id è una stringa
    getPrintItemById: state => id => state.cart ? state.cart.print_items.find(print_item => print_item.id == id) : null,

    getPhotoIdsByPrintItemIds: state => {
        if (state.cart) {
            // let printItemPhotoIds = []
            let photoIdsByPrintItemIds = {}
            state.cart.print_items.forEach(printItem => {
                let photoIds = printItem.photos.map(photo => photo.photo.id)
                // printItemPhotoIds = [...printItemPhotoIds, ...photoIds]
                photoIdsByPrintItemIds[printItem.id] = photoIds
            })
            return photoIdsByPrintItemIds
        }
    },

    getPhotoIdsInDigitalItem: (state, getters) => digitalItemId => {
        // ritorna array di photoId contenuti nel digital item in input
        const digitalItem = getters.getDigitalItemById(digitalItemId)
        return digitalItem.photos ? digitalItem.photos.map(photo => photo.id) : null
    },

    /**
     * Restituisce i print item che contengono almeno uno dei photo id passati come argomento
     *
     * @param {Array} photoIds elenco di photo id
     */
    getPrintItemsThatContainsPhotoIds: (state, getters) => photoIds => {
        const photoIdsByPrintItemIds = getters.getPhotoIdsByPrintItemIds
        console.log('photoIdsByPrintItemIds', photoIds, photoIdsByPrintItemIds)
        let printItemIdsToRemove = {}
        for (const [printItemId, printItemPhotoIds] of Object.entries(photoIdsByPrintItemIds)) {
            console.log(`${printItemId}: ${printItemPhotoIds}`)
            let intersection = printItemPhotoIds.filter(x => photoIds.includes(x))
            console.log('intersection.length', intersection.length)
            if (intersection.length > 0) {
                printItemIdsToRemove[printItemId] = intersection
                // printItemIdsToRemove.push(printItemId)
            }
        }
        return printItemIdsToRemove
    },

    getDigitalItemsTotalFormatted: state => state.cart && state.cart.price_summary.digital_items_total_formatted,
    getDigitalItemsTotalOriginalFormatted: state => state.cart && state.cart.price_summary.digital_items_total_original_formatted,
    getPrintItemsTotalFormatted: state => state.cart && state.cart.price_summary.print_items_total_formatted,
    getItemsTotalFormatted: state => state.cart && state.cart.price_summary.items_total_formatted,
    getShippingPrice: state => state.cart && state.cart.price_summary.shipping_total,
    getShippingPriceFormatted: state => state.cart && state.cart.price_summary.shipping_total_formatted,
    getGrandTotal: state => state.cart && state.cart.price_summary.grand_total,
    getGrandTotalFormatted: state => state.cart && state.cart.price_summary.grand_total_formatted,
    getDiscountTotal: state => state.cart && state.cart.price_summary.discount_total,
    getDiscountTotalFormatted: state => state.cart && state.cart.price_summary.discount_total_formatted,
    getHandlingFeeFormatted: state => state.cart && (state.cart.price_summary.handling_fee ? state.cart.price_summary.handling_fee_formatted : null),

    doesCartExist: state => !!state.cart,
    canAddPrintItems: state => false,

    hasShippingAddress: state => state.cart && state.cart.shipping_address_first_name,
    // isShippingAddressChanged: state => state.cart && state.shippingAddressChanged,
    getShippingAddressFields: state => {
        if (state.cart)
            return Object.keys(state.cart)
                .filter(key => key.startsWith('shipping_address_'))
                .reduce((obj, key) => {
                    obj[key] = state.cart[key]
                    return obj
                }, {})
    },
    getPaymentMethods: state => state.cart && state.cart.payment_methods,
    getPaymentSettings: state => state.cart && state.cart.payment_settings,

    getCampaignCode: state => state.campaign && JSON.parse(state.campaign).campaign_code,
    getCampaigExpDate: state => state.campaign && JSON.parse(state.campaign).campaign_expires_at,
    campaignIsValid: (state, getters) => {
        if (getters.getCampaignCode) {
            const today = new Date()
            const campaignExpireDate = new Date(getters.getCampaigExpDate)
            //console.log('campaign valid--->', today, campaignExpireDate,campaignExpireDate >= today)
            return campaignExpireDate >= today
        } else {
            return false
        }

    }
}


const mutations = {
    SET_CART(state, cart) {
        state.cart = cart
        state.shippingAddressExists = !!state.cart.shipping_address_first_name
    },
    SET_CART_EXISTS(state, exists) {
        state.cartExists = exists
    },

    TEARDOWN_CART(state) {
        // il teardown del carrello lo faccio chiedendo il cart (vuoto) tramite API
        state.shippingAddressExists = false
        state.shippingAddressChanged = false
    },

    SET_SHIPPING_ADDRESS_FIELD(state, payload) {
        // alla prima modifica di uno shipping field, setto come modificato
        state.shippingAddressChanged = true
        Vue.set(state.cart, payload.fieldName, payload.fieldValue)
    },

    SET_SHIPPING_ADDRESS_UNCHANGED(state) {
        state.shippingAddressChanged = false
    },

    SET_VOUCHER_CHECKIN_ID(state, id) {
        state.voucherCheckinId = id
    },

    SET_CAMPAIGN(state, campaign) {
        state.campaign = campaign
    },

    DELETE_CAMPAIGN() {
        state.campaign = ''
    }
}


const actions = {
     getCartExists(context, params) {
        return CartService.getCart({exists: true}, params)
            .then(response => {
                context.commit('SET_CART_EXISTS', response.data.exists)
                return response.data.exists
            })
            .catch(function (error) {
                return error
            })
    },
    getCart(context, params) {
        return CartService.getCart(params)
            .then(response => {
                context.commit('SET_CART', response.data)
                return response
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    addPrintItemToCart({dispatch}, product_configuration) {
        console.log('ACTION addPrintItemToCart')
        CartService.createCartPrintItem(product_configuration)
            .then(() => {
                dispatch('getCart')
                dispatch('emitFbPixelAddToCartEvent')
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    updatePrintItem({dispatch}, {printItemId, product_configuration}) {
        console.log('ACTION updatePrintItemToCart', printItemId, product_configuration)
        CartService.updateCartPrintItem(printItemId, product_configuration)
            .then(() => {
                dispatch('getCart')
            })
            .catch(function (error) {
                console.log('updatePrintItem ERROR', error)
                return error
            })
    },

    deletePrintItem({dispatch}, printItemId) {
        CartService.deleteCartPrintItem(printItemId)
            .then(() => {
                dispatch('getCart')
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    deletePhotoFromPrintItem({dispatch, getters}, payload) {
        const printItemId = payload.printItemId
        const photoIdsToRemove = payload.photoIds
        console.log('printItemId', printItemId)
        const printItem = getters.getPrintItemById(printItemId)
        console.log('printItem', printItem)

        let printItemEpurated = printItem.photos.filter(item => !photoIdsToRemove.includes(item.photo.id))
        printItem.photos = printItemEpurated
        console.log('printItemEpurated', printItem)

        dispatch('prints/getPrintItemProductConfigurationBody', printItem, {root: true})
            .then(body => {
                console.log('BODY THEN', body)
                dispatch('updatePrintItem', {
                    printItemId: printItemId,
                    product_configuration: body
                })
            })
    },

    deleteDigitalItem({commit}, digitalItemId) {
        CartService.deleteCartDigitalItem(digitalItemId)
            .then(response => {
                commit('SET_CART', response.data)
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    addDigitalItemToCart({commit, dispatch}, payload) {
        return CartService.createCartDigitalItemPhotolist(payload.picacode, payload.photoIds)
            .then(response => {
                console.log('createCartDigitalItemPhotolist THEN', response)
                commit('SET_CART', response.data)
                dispatch('emitFbPixelAddToCartEvent')
                // dispatch('getCart')
                // Vue.noty.success(`Foto aggiunta al carrello`)
                return response
            })
    },

    addDigitalItemToCartAsPackage({commit, dispatch}, {picacode, orderType}) {
        return CartService.createCartDigitalItemAsPackage(picacode, orderType)
            .then(response => {
                console.log('createCartDigitalItemAsPackage', response)
                commit('SET_CART', response.data)
                dispatch('emitFbPixelAddToCartEvent')
                // dispatch('getCart')
                //Vue.noty.success(`Tutte le foto dell'evento sono state aggiunte nel carrello`)
                return response
            })
    },

    setDigitalItemAsPackage({commit, dispatch}, {digitalItemId, orderType}) {
        return CartService.updateCartDigitalItemAsPackage(digitalItemId, orderType)
            .then(response => {
                commit('SET_CART', response.data)
                dispatch('emitFbPixelAddToCartEvent')
                // dispatch('getCart')
                //Vue.noty.success(`Tutte le foto dell'evento sono state aggiunte nel carrello`)
                return response
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    addCustomPackage({commit, dispatch}, {endpointUrl, checkinId}) {
        return axios.post(endpointUrl, {checkin_id: checkinId})
            .then(response => {
                commit('SET_CART', response.data)
                dispatch('emitFbPixelAddToCartEvent')
                return response
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    addPhotosToDigitalItem({commit, dispatch}, payload) {
        return CartService.addPhotoToCartDigitalItem(payload.digitalItemId, payload.photoIds)
            .then(response => {
                commit('SET_CART', response.data)
                dispatch('emitFbPixelAddToCartEvent')
                // dispatch('getCart')
                //Vue.noty.success(`Foto aggiunta al carrello`)
                return response
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    deletePhotosFromDigitalItem({commit}, payload) {
        return CartService.deletePhotosFromDigitalItem(payload.digitalItemId, payload.photoIds)
            .then(response => {
                commit('SET_CART', response.data)
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    deleteVideosFromDigitalItem({commit}, digitalItemId) {
        CartService.deleteVideosFromDigitalItem(digitalItemId)
            .then(response => {
                commit('SET_CART', response.data)
            })
            .catch(function (error) {
                console.log(error)
                return error
            })
    },

    saveShippingAddressFromStore(context) {
        return CartService.updatePrintOrder(context.state.cart.photosi_order_guid, context.getters.getShippingAddressFields)
            .then(() => {
                console.log('saveShippingAddress updatePrintOrder OK')
                context.dispatch('getCart')  // {include_only_price_summary: true} TODO: testare se sovrascrive digital_items, print_items, ecc
            })
    },

    saveShippingAddress(context, shippingAddressFields) {
        return CartService.updatePrintOrder(context.state.cart.photosi_order_guid, shippingAddressFields)
            .then(() => {
                console.log('saveShippingAddress updatePrintOrder OK')
                context.dispatch('getCart')  // {include_only_price_summary: true} TODO: testare se sovrascrive digital_items, print_items, ecc
            })
    },

    emitFbPixelPurchaseEvent({state}, {currency, amount}) {
        // Track Facebook Pixel "Purchase" event
        // NOTE: we retrieve "num_items" from the cart to avoid include them into the API response
        // https://developers.facebook.com/docs/facebook-pixel/reference
        if (typeof fbq === 'function') {
            // eslint-disable-next-line
            fbq('track', 'Purchase', {
                currency: currency,
                value: amount,
                num_items: state.cart.digital_items.length + state.cart.print_items.length
            })
        }

    },

    emitFbPixelAddToCartEvent() {
        // Track Facebook Pixel "AddToCart" event
        // eslint-disable-next-line
        if (typeof fbq === 'function') fbq('track', 'AddToCart')
    },

    placeOrder({state, dispatch, getters}, payload) {
        let campaignCode = getters.getCampaignCode
        //console.log('cc', campaignCode)
        if (campaignCode) {
            if (!getters.campaignIsValid) {
                campaignCode = null
                dispatch('deleteCampaign')
            }
        }


        return CartService.placeOrder(payload.paymentMethod, payload.paymentMethodId, payload.billingAddress, campaignCode)
            .then(response => {
                //console.log('placeOrder response', response)
                return response
            })
    },

    teardownCart({commit, dispatch}) {
        console.log('dispatch teardownCart')
        commit('TEARDOWN_CART')
        // we request a new cart version, actually empty
        dispatch('getCart')
    },

    deleteCampaign({commit}) {
        commit('DELETE_CAMPAIGN')
        localStorage.removeItem('campaign')
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
